<template>
  <b-card no-body>
    <b-row @click="toggle" :class="'mx-2 mt-2 mb-0' + (hasLongText ? ' clickable' : '')">
      <b-col>
        <slot name="short">
          {{ shortText }}
        </slot>
      </b-col>
      <b-col :cols="toggleCols">
        <font-awesome-icon
          class="mx-2"
          v-show="hasLongText"
          :icon="['fas', `chevron-${showLongText ? 'up' : 'down'}`]"
        />
      </b-col>
    </b-row>
    <b-row class="mx-2" v-if="showLongText">
      <b-col>
        <hr v-if="showHr" />
        <slot name="long">
          {{ longText }}
        </slot>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import EventBus from "@/services/EventBus";

export default {
  name: "Accordion",
  props: {
    toggleCols: {
      type: Number,
      default: 2
    },
    showHr: {
      type: Boolean,
      default: true
    },
    shortText: String,
    longText: String,
    groupId: String
  },

  mounted() {
    if (this.groupEventName) {
      EventBus.$on(this.groupEventName, this.onGroupClose);
    }
  },

  beforeUnmount() {
    if (this.groupEventName) {
      EventBus.$off(this.groupEventName, this.onGroupClose);
    }
  },

  data() {
    return {
      showLongText: false,
    };
  },

  computed: {
    hasLongText() {
      return this.$slots?.long?.length > 0;
    },
    groupEventName() {
      return this.groupId ? "AccordionOpened_Group_" + this.groupId : null;
    }
  },

  methods: {
    toggle() {
      if(this.hasLongText) {
        this.$emit("toggled", {
          oldValue: this.showLongText,
          newValue: !this.showLongText,
        });

        if (this.showLongText)
          this.close();
        else
          this.open();
      }
    },

    open() {
      this.showLongText = true;
      this.$emit("open");

      if (this.groupEventName)
        EventBus.$emit(this.groupEventName, this);
    },

    close() {
      this.showLongText = false;
      this.$emit("close");
    },

    onGroupClose(from) {
      if (this !== from)
        this.close();
    }
  },
};
</script>
